import React from "react";
import { useSelector } from "react-redux";
import Avatar from "../../../../components/Avatar";
import { Tooltip } from "../../../../components/DesignSystem";

import "./index.scss";

export function SidebarItem({ item, index, isOpenId, handleClickCase }) {
  const { keyword } = useSelector((state) => state.crm);

  function setSearchHighlight(string, value) {
    let newString = string;
    let valueIndex = newString.indexOf(value);
    if (valueIndex > 10 && newString.length > 20) {
      newString = `...${newString.slice(valueIndex - 10)}`;
    }

    return newString.replaceAll(value, `<strong>${value}</strong>`);
  }


  function returnTranslatedStatus(statusId) {
    switch (statusId) {
      case "SENT_CHAT":
      case "SENT":
        return "Aguardando resposta";
      case "NEGOTIATION_CHAT":
      case "NEGOTIATION":
        return "Em negociação";
      case "WAITING_APPROVAL_CHAT":
      case "WAITING_APPROVAL":
        return "Aguardando assinaturas";
      case "PAID_CHAT":
      case "PAID":
        return "Concluído";
      case "ARCHIVED_CHAT_OPERATOR":
      case "ARCHIVED_CHAT":
      case "ARCHIVED":
        return "Arquivado";
      case "WAITING_CHAT":
      case "WAITING":
        return "Aguardando assinatura e pagamento";
      case "CLOSED_CHAT":
      case "CLOSED":
        return "Encerrado";
      case 'CHAT NEGOTIATION':
        return "Em negociação por chat";
      default:
        return "Aguardando pagamento";
    }
  }

  return (
    <div
      key={item.caseId + index}
      className={
        item.caseId === isOpenId
          ? "sidebar__item sidebar__item--selected"
          : "sidebar__item"
      }
      onClick={() => handleClickCase(item)}
    >
      <div className="sidebar__item__col">
        <Avatar name={item.clientName} size="small" />
      </div>
      <div className="sidebar__item__col">
        <div className="sidebar__item__col__name">
          <Tooltip title={item.clientName}>
            <div
              dangerouslySetInnerHTML={{
                __html: setSearchHighlight(
                  item.clientName.replace(/<\/?[^>]+(>|$)/g, " "),
                  keyword
                ),
              }}
            />
          </Tooltip>
        </div>
        <div className="sidebar__item__col__description">
          {returnTranslatedStatus(item.status)}
        </div>
      </div>
      <div className="sidebar__item__col">
        {/* <div className="sidebar__item__col__hour">
          {renderDateTime(item.lastMessageDate)}
        </div> */}
        {!item.viewed && (
          <div className="sidebar__item__col__new-messages"></div>
        )}
      </div>
    </div>
  );
}
